import React, { FC } from 'react';
import { useErrorScreenState } from '@src/shared/context/error-screen'
import useStyles from './styles';
import ErrorScreenImage from '@assets/error_screen_image.png'
import JetDialog from '../JetDialog';
import JetButton from '../JetButton';
import { Typography, useMediaQuery, useTheme } from '@material-ui/core';
const ErrorScreenComponent: FC = () => {
    const { show: errorScreenIsVisible, confirmCallback, title, message, ctaTitle } = useErrorScreenState()
    const classes = useStyles();
    const isMobileScreen = useMediaQuery('(min-width:1024px)');
    const buttonSize = isMobileScreen ? 'medium' : 'small'
    const modalBody = (
        <div className={classes.paper}>
            <Typography variant='h4' className={`heading_m ${classes.title}`}>
                {title}
            </Typography>
            <Typography variant='body1' className='body_regular' align='left'>
                {message}
              </Typography>
            <div className={classes.imageContainer}>
                <img className='' src={ErrorScreenImage} />
            </div>
            <div>
                <JetButton className={classes.actionButton}
                    variation='primary'
                    size={buttonSize}
                    onClick={() => confirmCallback()}>
                    {ctaTitle}
                </JetButton>
            </div>

        </div>
    )
    return <JetDialog open={errorScreenIsVisible}>{modalBody}</JetDialog>

}

export default ErrorScreenComponent
